<template>
  <div
    class="m-wap-qrcode new cf"
    v-show="!isFrozen"
    v-if="extras.suspension.display == 1"
  >
    <!-- 报名图标 -->
    <div
      class="qrcode-item-container fl"
      v-if="extras.suspension.signUp == 'show'"
      v-show="(signUpQrCodeState && !memberInfo.signUpId) || isSetting == 1"
      @click="showBox('signup')"
    >
      <img
        class="qrcode-item-image"
        :src="extras && extras.suspension && extras.suspension.src"
        alt="立即报名"
      />
    </div>
    <!-- 签到码图标 -->
    <div
      class="qrcode-item-container fl"
      v-if="extras.suspension.signUpCode == 'show'"
      v-show="memberInfo.qrCode || isSetting == 1"
      @click="showBox('qrcode')"
    >
      <img
        class="qrcode-item-image"
        :src="extras && extras.suspension && extras.suspension.img"
        alt="微信"
      />
      <div
        class="qrcode-item qrcode-item-height"
        v-show="isShowBox === 'qrcode'"
      >
        <div class="qrcode-close-container" @click.stop="closeBox"></div>
        <div
          class="qrcode-item-title text-center"
          v-if="memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3"
        >
          报名成功，期待您的莅临
        </div>
        <div
          class="qrcode-item-title text-center"
          v-if="memberInfo.signUpStatus == 1"
        >
          报名成功,审核中
        </div>
        <div
          class="qrcode-item-title text-center"
          v-if="memberInfo.signUpStatus == 4"
        >
          报名人数已满
        </div>
        <div style="position: relative">
          <div class="qrcode-item-qrcode">
            <div id="j-qrcode"></div>
          </div>
          <div
            class="qrcode-item-qrcode"
            style="position: absolute; top: 0; left: 0; right: 0"
            v-if="memberInfo.signUpStatus == 1 || memberInfo.signUpStatus == 4"
          >
            <img src="../../assets/images/wap/mohu.png" />
          </div>
        </div>
        <div
          class="qrcode-item-id text-center"
          v-if="memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3"
        >
          参会人ID：{{ memberInfo.signUpId }}
        </div>
        <div
          class="qrcode-item-tips text-center"
          v-if="memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3"
        >
          现场需要向主办方出示
        </div>
      </div>
    </div>
    <!-- 分享图标 -->
    <div
      v-if="extras.suspension.share == 'show'"
      v-show="sharePosterUrl || isSetting == 1"
      class="qrcode-item-container fl"
      @click="showBox('share')"
    >
      <img
        class="qrcode-item-image"
        :src="extras && extras.suspension && extras.suspension.thumbnail"
        alt="分享"
      />
    </div>

    <div
      v-if="extras.suspension.wechat == 'show'"
      v-show="seminarInfo.weChatType === 'custom' || isSetting == 1"
      class="qrcode-item-container fl"
      @mouseover="showBox('wechat')"
      @mouseout="closeBox()"
    >
      <img
        class="qrcode-item-image"
        :class="{
          'cursor-default': isSetting == 1,
        }"
        :src="extras && extras.suspension && extras.suspension.logo"
        alt="微信"
      />
      <div
        class="custom-item qrcode-item-wechat"
        v-show="isShowBox === 'wechat'"
      >
        <div class="custom-item-container">
          <div class="qrcode-item-title text-center">长按识别二维码</div>
          <img
            class="qrcode-item-qrcode-image"
            :src="seminarInfo.weChatQrCodeUrl"
          />
        </div>
      </div>
    </div>

    <div
      v-if="extras.suspension.question == 'show'"
      class="qrcode-item-container fl"
      @click="showQuestionIframe"
    >
      <img
        class="qrcode-item-image"
        :class="{
          'cursor-default': isSetting == 1,
        }"
        :src="extras && extras.suspension && extras.suspension.imgSrc"
        alt="问卷"
      />
    </div>
    <!-- 自定义图标1 -->
    <div
      class="qrcode-item-container fl"
      v-if="extras.suspension.customIcon == 'show'"
      @mouseover="clickCustom('custom')"
      @mouseout="closeBox()"
    >
      <img
        class="qrcode-item-image"
        :src="extras && extras.suspension && extras.suspension.iconSrc"
      />
      <div class="custom-item" v-show="isShowBox === 'custom'">
        <div class="custom-item-container">
          <img
            class="custom-item-image"
            :src="extras && extras.suspension && extras.suspension.modalSrc"
          />
        </div>
      </div>
    </div>
    <!-- 自定义图标2 -->
    <div
      class="qrcode-item-container fl"
      v-if="extras.suspension.customIcon2 == 'show'"
      @mouseover="clickCustom2('custom2')"
      @mouseout="closeBox()"
    >
      <img
        class="qrcode-item-image"
        :src="extras && extras.suspension && extras.suspension.iconurl"
      />
      <div class="custom-item" v-show="isShowBox === 'custom2'">
        <div class="custom-item-container">
          <img
            class="custom-item-image"
            :src="extras && extras.suspension && extras.suspension.modalSrc2"
          />
        </div>
      </div>
    </div>
    <div
      class="qrcode-item-container fl back"
      v-if="extras.suspension.backTop == 'show'"
      @click="returnTop()"
    >
      <img
        class="qrcode-item-image back"
        :src="extras && extras.suspension && extras.suspension.imgurl"
        alt="返回顶部"
      />
    </div>
    <div class="frame-outer-wap" v-if="showFrame">
      <div class="sign-frame" :style="{ top: top }">
        <span class="icontemp stemp-close" @click="closeFrame"></span>
        <iframe frameborder="0" :src="questionUrl"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { URLS } from "fire-wind-water/index";
import { userModel } from "../../mixins/user";
import { sdeModel } from "../../mixins/sde";
import { posterModel } from "../../mixins/poster";
import { $subscriber } from "fire-wind-water";
import { goto } from "../../mixins/goto";
import Api from "@/service/api";

export default {
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    extras: Object,
    markCode: String,
    signUpStatus: Number,
    isFrozen: Boolean,
  },
  data() {
    return {
      isLogin: false,
      isSetting: 0,
      signUpQrCodeState: false,
      signUpWap: "",
      isShowBox: "",
      sharePosterUrl: "",
      qrcodeList: [],
      isShowTop: false,
      showQuestion: true,
      questionId: "",
      questionUrl: "",
      scale: 1,
      showFrame: false,
      user: {},
      top: "",
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  watch: {
    "memberInfo.qrCode"(val) {
      if (val) {
        this.setQrcode("j-qrcode", this.memberInfo.qrCode);
      }
    },
  },
  mounted() {
    userModel.user.module(this);
    sdeModel.seminar.module(this);
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    if (this.memberInfo.qrCode) {
      this.setQrcode("j-qrcode", this.memberInfo.qrCode);
    }
    this.getDefaultQestion();
  },
  methods: {
    closeFrame() {
      this.top = "100vh";
      document.body.style.setProperty("overflow", "auto");
      setTimeout(() => {
        this.showFrame = false;
      }, 400);
    },
    showQuestionIframe() {
      if (this.questionId) {
        this.showFrame = true;
        document.body.style.setProperty("overflow", "hidden");
        setTimeout(() => {
          this.top = "20vh";
        }, 100);
      } else {
        alert("暂无问卷");
      }
    },

    getDefaultQestion() {
      const param = {
        tenantId: this.seminarInfo.tenantId,
        moduleId: 3,
        instanceId: this.seminarInfo.instanceId,
        type: "question",
      };
      Api.getDefaultQestion(param).subscribe((res) => {
        if (res.result == 0 && res.content.objId != "-2") {
          this.questionId = res.content.objId;
          this.questionUrl = res.content.wap.normal;
        }
      });
    },
    returnTop() {
      let timer = setInterval(() => {
        // 获取当前滚动高度
        const top =
          document.body.scrollTop || document.documentElement.scrollTop;
        // 设置滚动速度
        const speed = top / 4;
        if (document.body.scrollTop !== 0) {
          document.body.scrollTop -= speed;
        } else {
          document.documentElement.scrollTop -= speed;
        }
        if (top === 0) {
          clearInterval(timer);
        }
      }, 20); // 设置触发频率，数值越小动画越流畅，但是事件触发次数越多
    },
    skSeminarEnd(res) {
      if (res.signUpWap && res.status !== "completed") {
        this.signUpQrCodeState = true;
      }
    },
    skSeminarUserEnd() {
      posterModel.poster.module(this);
      if (this.memberInfo.qrCode) {
        this.setQrcode("j-qrcode", this.memberInfo.qrCode);
      }
    },
    skPosterEnd() {
      setTimeout(() => {
        this.sharePosterUrl = goto.poster(true);
        console.log(this.sharePosterUrl);
      }, 100);
    },

    showBox(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (e === "signup") {
        $subscriber.emit("wap-goSign");
        //        goto.signUp();
        return;
      }
      if (e === "share") {
        goto.poster();
        return;
      }
      this.isShowBox = e;
    },
    closeBox() {
      this.isShowBox = "";
    },
    clearSession() {
      this.sharePosterUrl = "";
    },
    setQrcode(domId, text) {
      setTimeout(() => {
        if (this.qrcodeList.indexOf(domId) < 0) {
          this.qrcodeList.push(domId);
          new QRCode(domId, {
            width: 158,
            height: 158,
            text,
            colorDark: "#000",
            colorLight: "#fff",
          });
        }
      }, 0);
    },
    clickCustom(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (this.extras.suspension.designType == "1") {
        // 交互方式 1-点击弹层 2-跳转链接
        this.isShowBox = e;
      } else if (
        this.extras.suspension.designType == "2" &&
        this.extras.suspension.sidebarLink
      ) {
        window.$sk.goto(this.extras.suspension.sidebarLink);
      }
    },
    clickCustom2(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (this.extras.suspension.designType2 == "1") {
        // 交互方式 1-点击弹层 2-跳转链接
        this.isShowBox = e;
      } else if (
        this.extras.suspension.designType2 == "2" &&
        this.extras.suspension.sidebarLink2
      ) {
        window.$sk.goto(this.extras.suspension.sidebarLink2);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
